export const BIRTHDAY_ROOM_REQUEST = 'familyFilmClub/BIRTHDAY_ROOM_REQUEST';
export const BIRTHDAY_ROOM_SUCCESS = 'familyFilmClub/BIRTHDAY_ROOM_SUCCESS';

export const FAMILY_FILM_CLUB_REQUEST = 'familyFilmClub/FAMILY_FILM_CLUB_REQUEST';
export const FAMILY_FILM_CLUB_SUCCESS = 'familyFilmClub/FAMILY_FILM_CLUB_SUCCESS';
